/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { map, size, compact, round } from 'lodash';
import { Table } from 'antd';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import DateTime from 'components/date-time';

/**
 * Style dependencies
 */
import './styles.scss';

const ImageListTable = ({ items, requestItems, requesting, images, ...props }) => {
    const dataSource = map(items, (r) => {
        return r;
    });

    const columns = [
        {
            title: 'Image',
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: 'Received',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (created_at) => {
               return <DateTime date={created_at} format='Do MMM, YYYY HH:mm:ss' />;
            },
        },
    ];

    return (
        <Box>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                loading={requesting}
                scroll={{ x: 'max-content' }}
            />
        </Box>
    );
};

export default connect(null, {
})(ImageListTable);
